<template>
  <v-card outlined elevation="1" color="grey lighten-4">
    <v-card-text v-if="!editActive">
      <v-list-item three-line>
        <v-list-item-content>
          <span class="overline">
            <v-btn text small color="blue" @click="editMode = true" :disabled="editMode">
              <v-icon small left>
                mdi-pencil
              </v-icon>
              Údaje pro seřízení
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small left
                  v-bind="attrs"
                  v-on="on">
                    mdi-help-circle
                </v-icon>
              </template>
              <span>Řekněte nám něco o sobě. Pomůže to při výběru vhodné velikosti i pro správné seřízení.</span>
            </v-tooltip>
          </span>
          
          <v-list-item-subtitle class="attributes">
            <span v-if="subjectProfileLocal.name" class="headline mb-1">{{ $t(subjectProfileLocal.name) }}</span>
            <span v-if="subjectProfileLocal.age">{{ subjectProfileLocal.age }} let</span>
            <span v-if="subjectProfileLocal.gender">{{ $t(subjectProfileLocal.gender) }}</span>
            <span v-if="subjectProfileLocal.height">{{ subjectProfileLocal.height }} cm</span>
            <span v-if="subjectProfileLocal.weight">{{ subjectProfileLocal.weight }} kg</span>
            <span v-if="subjectProfileLocal.shoeSize">bota: {{ subjectProfileLocal.shoeSize }}</span>
            <span v-if="subjectProfileLocal.rentAbilityLevel">{{ $t(subjectProfileLocal.rentAbilityLevel) }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>

    <v-card-text v-else>
      <span class="overline">
        Údaje pro seřízení
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small left
              v-bind="attrs"
              v-on="on">
                mdi-help-circle
            </v-icon>
          </template>
          <span>Řekněte nám něco o sobě. Pomůže to při výběru vhodné velikosti i pro správné seřízení.</span>
        </v-tooltip>
      </span>
      <subject-profile-form
        v-bind:subjectProfile="subjectProfileLocal"
        v-bind:rentProductTypes="rentProductTypes"
        v-on:change="subjectProfileFormChange"
      ></subject-profile-form>
    </v-card-text>
  </v-card>
</template>

<script>
import SubjectProfileForm from "@/components/SubjectProfileForm";

export default {
  name: "SubjectProfile",

  components: {
    SubjectProfileForm,
  },

  props: {
    subjectProfile: {
      required: true,
    },

    rentProductTypes: {
      type: Array,
      required: true,
    },

    shouldBeVisible: {
      type: Boolean,
      required: true
    },

    shouldBeRequired: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      editMode: false,
    };
  },

  computed: {
    subjectProfileLocal() {
      console.log(this.subjectProfile);
      return { ...this.subjectProfile };
    },
    
    editActive() {
      return this.editMode || (this.subjectProfile == null && this.shouldBeRequired);
    }
  },

  methods: {
    subjectProfileFormChange(subjectProfile) {
      this.editMode = false;
      this.$emit("change", subjectProfile);
    },
  },
};
</script>

<style>
.attributes span {
  margin: 0 0.5rem;
}
</style>
